/**
 * Local Preference Keys
 */
export enum StorageKey {
  /** Whether to display defects in the sidepanel view or in a modal */
  defectSidePanel = "defect-side-panel",
  /** Controls default option for the Comments, History, or All component */
  defectActivityOption = "defect-activity-option",
  defaultTenantGuid = "tenantguid",
  username = "username",
  clientTenantId = "clienttenantid",
  readMessageIds = "readMessageIds",
}
